import axios from 'axios';
import { BASE_URL, CLIENT } from './endpoints';

const CLIENT_BASE_URL = BASE_URL + CLIENT.BASE;

export const fetchInvoice = (clientId: any, year: any) => {
  return axios.get(`${CLIENT_BASE_URL}/invoice/${clientId}?year=${year}`);
};
